import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Permissions } from '@app/Models/Permissions';
import { PermissionService } from '@app/Services';

@Injectable({
  providedIn: 'root'
})
export class TrialGuard  {

  constructor(private router: Router, private permissionService: PermissionService) {}

  canActivate(): boolean {
    if (this.permissionService.hasPermission(Permissions.freeTrialAdministration)) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
